module.exports = __webpack_public_path__ + "static/media/HCMM350.2ed60071.jpg";